import { DomainError } from 'scripts/application/lib/error';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';
import htmlToText from 'models/conversation_item/html_to_text';

export default class SendTaskThreadEmail {
  constructor(context) {
    this.context = context;
  }

  // onSent fires only once the reply is accepted, onError with the backend's field errors, and
  // onSettled either way. executeAction defers through setImmediate and discards the return value, so
  // the caller can't await this — it hands us callbacks instead.
  run({ taskId, from, to, cc, subject, bodyHtml, dueAt, onSent, onError, onSettled }) {
    if (!taskId) {
      throw new Error('SendTaskThreadEmail must be called with a task id');
    }

    return this.context.gateways.taskThreadMessages
      .add(
        { taskId },
        {
          channel: 'EMAIL',
          dueAt,
          email: {
            from,
            to: asAddresses(to),
            cc: asAddresses(cc),
            subject,
            body: { html: bodyHtml, text: htmlToText(bodyHtml) },
          },
        }
      )
      .then(() => onSent && onSent())
      .catch(err => {
        // A field error names what to fix (a from address too long to carry the thread token, say),
        // so it goes back to the editor rather than into a generic toast.
        if (err instanceof DomainError && onError) {
          onError(err.errors);
          return;
        }
        handleCommonErrors(this.context, err);
      })
      .finally(() => onSettled && onSettled());
  }
}

function asAddresses(emails) {
  return (emails || []).map(email => ({ email }));
}
